import { emails, links } from '@farmersdog/constants';
import type { LinkProps } from '@farmersdog/corgi';

import CellPhoneSvg from './assets/cell-phone.svg';
import FacebookSvg from './assets/facebook.svg';
import InstagramSvg from './assets/instagram.svg';
import MailSvg from './assets/mail.svg';
import MediaInquirySvg from './assets/media-inquiry.svg';

import type { SVGProps, ReactSVGElement } from 'react';

interface ContactLink extends LinkProps {
  label: string;
  icon: (props: SVGProps<SVGSVGElement>) => ReactSVGElement;
}

export function useContactLinks() {
  // const { phone, email } = useCxContact('prospective', 'footer');
  const phone = true;
  const email = true;

  const contactLinks: ContactLink[] = [
    email && {
      href: `mailto:${emails.EMAIL_HELP}`,
      icon: MailSvg,
      label: 'help@thefarmersdog.com',
    },
    phone && {
      href: 'tel:+16467807957',
      icon: CellPhoneSvg,
      label: '(646)-780-7957',
    },
    {
      href: links.LINK_IG,
      icon: InstagramSvg,
      label: 'Instagram',
      target: '_blank',
      rel: 'noopener noreferrer',
    },
    {
      href: links.LINK_FB,
      icon: FacebookSvg,
      label: 'Facebook',
      target: '_blank',
      rel: 'noopener noreferrer',
    },
    {
      href: `mailto:${emails.EMAIL_PRESS}`,
      icon: MediaInquirySvg,
      label: 'Media Inquiries',
    },
  ];

  return contactLinks.filter(Boolean);
}
